import { render } from "./EdicionContrato.vue?vue&type=template&id=0ca1c64e&scoped=true"
import script from "./EdicionContrato.js?vue&type=script&lang=js"
export * from "./EdicionContrato.js?vue&type=script&lang=js"

import "./EdicionContrato.vue?vue&type=style&index=0&id=0ca1c64e&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca1c64e"]])

export default __exports__